export default __webpack_public_path__ + "static/media/slideCampaign-4.9b3bcf48.png";